"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var defaultSeo = {
  title: 'Home',
  titleTemplate: '%s | ELEVATOR',
  description: 'The dopest new hip hop, upcoming artsits, music news, culture, and style.',
  openGraph: {
    type: 'website',
    url: 'https://elevatormag.com',
    title: 'ELEVATOR',
    description: 'The dopest new hip hop, upcoming artsits, music news, culture, and style.',
    images: [{
      url: 'https://elevator-media.imgix.net/static/Auth_Image.png?w=400&h=300&ixlib=js-2.1.2&s=fd8188e03470f231bae5d43e90014e97',
      width: 400,
      height: 300,
      alt: 'ELEVATOR image'
    }]
  },
  twitter: {
    site: '@ELEVATOR_',
    cardType: 'app'
  }
};
var _default = exports.default = defaultSeo;